import { useMsal } from "@azure/msal-react";
import { InteractionRequiredAuthError, InteractionStatus } from "@azure/msal-browser";
import { loginRequest } from "../Azure-ad/authConfig";
import { loginRequestB2c } from "../Azure-ad/authConfigB2c"
import { useNavigate } from 'react-router-dom';
import { Spinner } from "react-bootstrap";
import Alert from './Alert';
import React, { useState, useEffect } from 'react';
import { setUserInfo, getUserInfo, getDashboard, setDashboard } from './functions/userInfo';
import { environment } from './functions/environment';

import { getToken } from '../Azure-ad/authService';
import { useAuth } from '../Azure-ad/AuthContext';
var webDid ;
function AzureRedirect(props) {
    const { setToken } = useAuth();

    const navigate = useNavigate();
    let [deviceID, setDeviceID] = useState("");
    let [alert, setAlert] = useState({
        msg: "",
        status: false
    });

    function handleLogout(instance) {
        instance.logoutRedirect().catch(e => {
            console.error(e);
        });
    }

    useEffect(() => {
        const adType = sessionStorage.getItem("adType");
        checkCookie();
        handleGetToken(adType);
    }, []);

    //try
    const handleGetToken = async (type) => {
        try {
            const token = await getToken(type, setToken);
            // console.log('Access token:', token);
            let loginUser = sessionStorage.getItem('userInfo') ? getUserInfo() : null;
            if (loginUser) {
                if (loginUser.token != "" || loginUser.token != null) {
                    if (loginUser.userType == "admin") {
                        navigate('/accounts');
                    }
                    else if (loginUser.userType == "technician_user") {
                        navigate('/preventive_maintenance');
                    }
                    else {
                        navigate('/my-equipment');
                    }
                }
                else {
                    loginApi(token);
                }
            }
            else {
                loginApi(token);
            }
            sessionStorage.setItem("adType", type);
        } catch (error) {
            console.error('Error getting token:', error);

        }
    };
    
    // for device ID
    function dec2hex(dec) {
        return dec < 10
            ? '0' + String(dec)
            : dec.toString(16)
    }
    //for cockies
    function generateId(len) {
        var arr = new Uint8Array((len || 40) / 2)
        window.crypto.getRandomValues(arr)
        return Array.from(arr, dec2hex).join('')
    }

    function setCookie(cname, cvalue, exdays) {
        const d = new Date();
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
        let expires = "expires=" + d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    }

    function getCookie(cname) {
        let name = cname + "=";
        let decodedCookie = decodeURIComponent(document.cookie);
        let ca = decodedCookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }

    function checkCookie() {
        let did = getCookie("deviceID");
        if (did != "") {
            setCookie("deviceID", did, 90);
            webDid = did;
            setDeviceID(did);
        } else {
            let id = generateId(20);
            setCookie("deviceID", id, 90);
            webDid = id;
            setDeviceID(id)
        }
    }
    //for cockies
    function getBrowserName() {
        if ((navigator.userAgent.indexOf("Opera") || navigator.userAgent.indexOf('OPR')) != -1) {
            return ('Opera');
        }
        else if (navigator.userAgent.indexOf("Edg") != -1) {
            return ('Edge');
        }
        else if (navigator.userAgent.indexOf("Chrome") != -1) {
            return ('Chrome');
        }
        else if (navigator.userAgent.indexOf("Safari") != -1) {
            return ('Safari');
        }
        else if (navigator.userAgent.indexOf("Firefox") != -1) {
            return ('Firefox');
        }
        else if ((navigator.userAgent.indexOf("MSIE") != -1) || (!!document.documentMode == true)) //IF IE > 10
        {
            return ('IE');
        }
        else {
            return ('unknown');
        }
    }
    function getDashboardByUser(token) {
        fetch(environment.baseUrl + "getDashboardByUser?", {
            method: "GET",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token
            }
        }).then((result) => {
            result.json().then((res) => {
                if (res.code === 200) {
                    let temp = [];
                    if (res.data.result.length) {
                        res.data.result.map((item) =>
                            temp.push(item.dashboardID)
                        )
                        setDashboard(temp);
                        const dashboard = getDashboard();
                        if (dashboard) {
                            navigate('/my-equipment');
                        }
                        else {
                            navigate('/profile');
                        }
                    }
                }
            })
        })
    }
    function loginApi(val) {
        sessionStorage.clear();
        fetch(environment.baseUrl + "azureLogin", {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + val
            },
            body: JSON.stringify({
                deviceType: "web",
                deviceID: webDid,
                deviceDetails: {
                    webBrowser: getBrowserName(),
                }
            })
        }).then((result) => {
            result.json().then((res) => {
                if (result.status === 200 || res.code === 200) {
                    setUserInfo(res.data.result);
                    if (res.data.result.userType == "admin") {
                        setDashboard([null]);
                        navigate('/accounts');
                    }
                    else if (res.data.result.userType == "technician_user") {
                        setDashboard([null]);
                        navigate('/preventive_maintenance');
                    }
                    else if (res.data.result.userType === "account_user") {
                        getDashboardByUser(res.data.result.token);
                    }
                    props.aapFun(true);
                }
                else {
                    setAlert({
                        msg: res.msg,
                        status: true
                    });
                    setTimeout(function () {
                        navigate('/login');
                    }, 3000)
                }
            })
        })
    }

    // for get token
    return (
        <div className='container'>
            <div className="row align-items-center text-center" style={{ height: "100vh" }}>
                <div className="col-12">
                    <Alert obj={alert} />
                    <Spinner animation="border" variant="primary" />
                    <p>Loading...</p>
                </div>
            </div>
        </div>
    )
}

export default AzureRedirect
